/* eslint-disable no-param-reassign */
'use strict';
define('oldDomControl',['jquery', 'settings', 'translations', 'codes'], function ($, settings, T, codes) {
	var domElements = {
			body: $('body'),
			wrapper: $('#content-wrapper'),
			fadeout: $('#fadeout'),
			error: $('#error')
		},
		gameSettings,
		gamesTimeLeft = 0,
		preventSliding = true; // Old template only for single games

	function loadTemplate(content) {
		domElements.wrapper.html(content);

		gameSettings = settings.games[0];

		loadSelectors();
		translateFields();
	}

	function showBets(bets) {
		displayBets(bets);
	}

	function formatOdd(number) {
		var wantedLen,
			wholeDigitNum,
			scale;

		if (number <= 1) {
			return '-';
		}
		wantedLen = 3;
		wholeDigitNum = Math.floor(Math.log10(number)) + 1;
		if (wholeDigitNum < wantedLen) {
			scale = Math.pow(10, wantedLen - wholeDigitNum);
			return (Math.floor((number * scale).toPrecision(12)) / scale).toPrecision(wantedLen);
		}
		return Math.floor(number);
	}

	function doubleDigit(no) {
		return no < 10 ? '0' + no : no;
	}

	function formatTime(date) {
		var time = [
			doubleDigit(date.getHours()),
			doubleDigit(date.getMinutes()),
			doubleDigit(date.getSeconds())
		].join(':');

		return time;
	}

	function loadSelectors() {
		domElements = Object.assign(domElements, {
			wheel: $('#game-content #wheel'),
			rngWheel: $('#game-content #rng-wheel'),
			dice: $('#game-content #dice'),
			lucky5: $('#game-content #lucky5'),
			lucky7: $('#game-content #lucky7'),
			header: {
				name: $('header .left .logo'),
				timeLeft: $('header #next-draw #time-remaining'),
				instanceId: $('header #next-draw #next-instance-id')
			},
			rightSide: $('#right-side'),
			popularOdds: $('#right-side .popular-odds .odds'),
			allOdds: $('#right-side .all-odds .odds'),
			pageProgressNo: $('.pages .page-count'),
			pageProgressBar: $('.pages .progress-bar span')
		});
	}

	function translateFields() {
		var gameConfig = gameSettings.config[gameSettings.module];

		domElements.body.attr('data-template', settings.local.template);

		domElements.history = {
			container: $('#content-wrapper #' + gameConfig.gameType + ' #history'),
			resultBlocks: $('#content-wrapper #' + gameConfig.gameType + ' #history .result.block')
				.toArray()
		};
		domElements.history.container.find('.time .name')
			.html(T.translate('translate_date'));
		domElements.history.container.find('.time')
			.after('<div class="separator_dash"><span class="value">-</span></div>');
		domElements.history.container.find('.instance .name')
			.html(T.translate('translate_inst_history'));

		domElements.header.name.html(T.translate(gameConfig.gameType));
		domElements.history.container.find('h2').html(T.translate('translate_prev'));
		domElements.popularOdds.parent().find('.header')
			.html(T.translate('translate_' + gameConfig.gameType + '_bets'));
		domElements.allOdds.parent().prev('.header')
			.html(T.translate('translate_all_bets') + '<span class="additional_message">' +
				T.translate('translate_additional_message') + '</span>');
		domElements.header.instanceId.prev('.next-text')
			.html(T.translate('translate_inst'));
		domElements.history.container.next('.all-bet-at')
			.find('.all-message').html(T.translate('translate_all_bets_at'));

		domElements.body.attr('data-game', gameConfig.gameType);
	}

	function startSlider() {
		if (!preventSliding) {
			return;
		}
		preventSliding = false;

		pageSlider(0);
	}

	function stopSlider() {
		preventSliding = true;
	}

	function pageSlider(currentP) {
		var w = $('#right-side').width(),
			d = domElements.allOdds.find('.all-odds-page').length;

		if (!preventSliding) {
			domElements.allOdds.animate({ marginLeft: ((w * currentP) * (-1)) }, 200);
			domElements.pageProgressBar.animate({ width: '0%' }, 0);
			domElements.pageProgressBar.animate({ width: '100%' }, settings.local.changeSpeed);
			domElements.pageProgressNo.text(currentP + 1 + '/' + d);

			if (settings.local.sliding) {
				setTimeout(function () {
					if (currentP + 1 === d) {
						currentP = 0;
					} else {
						currentP += 1;
					}
					pageSlider(currentP, true);
				}, settings.local.changeSpeed);
			}
		}
	}

	function showScreen() {
		domElements.fadeout.fadeOut(500, 'linear');
	}

	function updateHistory(data) {
		var i,
			currentBlock;

		for (i = 0; i < data.length && i < domElements.history.resultBlocks.length; i++) {
			currentBlock = $(domElements.history.resultBlocks[i]);
			setResultData(currentBlock, data[i]);
		}
	}

	function displayBets(data) {
		var popularOddsHtml = '',
			allOddsHtml = '',
			name = '',
			code = '',
			i,
			d,
			ct = 0,
			w = $('#right-side').width(),
			popular = [
				'lucky7.numbers.one_drop',
				'lucky7.numbers.two_drop',
				'lucky7.oddeven.last_odd',
				'lucky7.oddeven.first_two_even',
				'lucky7.color.first_yellow',
				'lucky7.color.first_black',
				'dice.combinations.atleast_one_pair',
				'dice.combinations.any_two_pairs',
				'dice.combinations.three_any_kind',
				'dice.combinations.sequence_1_5',
				'dice.combinations.sequence_2_6',
				'dice.combinations.all_different',
				'lucky5.color.red_more_than_green',
				'lucky5.numbers.one_drop',
				'lucky5.numbers.two_drop',
				'lucky5.numbers.three_drop',
				'lucky5.numbers.more_even',
				'lucky5.numbers.more_92_5',
				'lucky6.numbers.one_drop_zone_a',
				'lucky6.numbers.one_drop_zone_b',
				'lucky6.numbers.one_drop_zone_c',
				'lucky6.numbers.two_drop_zone_a',
				'lucky6.numbers.two_drop_zone_b',
				'lucky6.numbers.two_drop_zone_c'
			];

		for (i = 0; i < data.length; i++) {
			name = T.translate(data[i].name);
			code = codes[data[i].name];
			if (popular.indexOf(data[i].name) > -1 || data[i].name.indexOf('wheel') > -1) {
				popularOddsHtml += '<li><span class="bet_code">' + code + '</span><span class="name">' +
					name + '</span><span class="odd">' + formatOdd(data[i].odd) + '</span></li>';
			} else {
				if (ct === 0) {
					allOddsHtml +=
						'<div class="all-odds-page" style="float:left; width:' + w + 'px;"><ul>';
				}
				ct++;
				allOddsHtml += '<li><span class="bet_code">' + code + '</span><span class="name">' +
					name + '</span><span class="odd">' + formatOdd(data[i].odd) + '</span></li>';
				if (ct === 7 || (i + 1) === data.length) {
					ct = 0;
					allOddsHtml += '</ul></div>';
				}
			}
		}
		domElements.popularOdds.html(popularOddsHtml);
		domElements.allOdds.html(allOddsHtml);
		if (allOddsHtml.length === 0) {
			preventSliding = true;
			domElements.rightSide.find('.popular-odds').addClass('full-height');
			domElements.rightSide.find('.all-odds').remove();
			domElements.rightSide.find('.pages').remove();
		}

		d = domElements.allOdds.find('.all-odds-page').length;
		domElements.allOdds.css('width', d * w);
		domElements.pageProgressNo.text('1/' + d);
	}

	function setResultData(domBlock, data) {
		var results = '',
			j,
			result;

		domBlock.find('.time .value').html(formatTime(new Date(data.startTime)));
		domBlock.find('.instance .value').html(data.code);

		if (data.cancelled) {
			results = '<div class="big-text">' + T.translate('translate_cancelled') + '</div>';
		} else if (data.result && data.result.length) {
			for (j = 0; j < data.result.length; j++) {
				// If result has a letter strip it
				result = data.result[j];
				if ((/^[A-Z]/).test(data.result[j])) {
					result = data.result[j].slice(1);
				}
				results += '<span data-result="' + data.result[j] + '">' + result + '</span>';
			}
		} else {
			results = T.translate('translate_waiting');
		}
		domBlock.find('.right').html(results);
		domBlock.addClass('active');
	}

	function setTimeLeft(time) {
		gamesTimeLeft = time >= 0 ? time : 0;
	}

	setInterval(function () {
		var formattedTime;

		if (gamesTimeLeft > 0) {
			gamesTimeLeft -= 1;
			formattedTime = ('0' + Math.floor(gamesTimeLeft / 60)).slice(-2) + ':' +
				('0' + gamesTimeLeft % 60).slice(-2);
			domElements.header.timeLeft.html(formattedTime);
		}
	}, 1000);

	return {
		nextGame: function (data) {
			domElements.header.instanceId.html(data.code);
		},
		elements: domElements, // Some services needs active dom variables
		resetBids: function () { }, // This template has no bids
		updateBids: function () { }, // ---- || ----
		setSlider: function () { }, // This template has no yellow line slider
		actionBeforeStream: function () {
			domElements.wrapper.hide();
			preventSliding = true;
		},
		actionAfterStream: function () {
			domElements.wrapper.show();
			startSlider();
		},
		showHistory: updateHistory,
		loadTemplate: loadTemplate,
		showBets: showBets,
		startSlider: startSlider,
		stopSlider: stopSlider,
		setTimeLeft: setTimeLeft,
		showScreen: showScreen,
		errorDisplay: function (message, time) {
			domElements.error.html(T.translate(message)).fadeIn(500);
			setTimeout(function () {
				domElements.error.fadeOut(500);
			}, time);
		}
	};
});

